import axiosApi from '@apis/axiosApi'
import { handleError } from '@utils/commonUtils'

const BASE = '/don-tu/quy-trinh-duyet'

// Lấy danh sách cấu hình workflow
export function layDanhSachCauHinhWorkflow() {
  try {
    return axiosApi.get(`${BASE}/cau-hinh-quy-trinh`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy thông tin cấu hình workflow theo ID
export function layCauHinhWorkflow(id: number) {
  try {
    return axiosApi.get(`${BASE}/cau-hinh-quy-trinh/${id}`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy cấu hình workflow theo loại đơn và phòng ban (BE: filter qua query nếu có)
export function layCauHinhWorkflowTheoLoai(requestType: string, departmentId?: number) {
  try {
    const query: any = { requestType }
    if (departmentId) query.departmentId = departmentId
    return axiosApi.get(`${BASE}/cau-hinh-quy-trinh`, { params: query })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Tạo cấu hình workflow mới
export function taoCauHinhWorkflow(params: any) {
  try {
    return axiosApi.post(`${BASE}/cau-hinh-quy-trinh`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Cập nhật cấu hình workflow
export function capNhatCauHinhWorkflow(id: number, params: any) {
  try {
    return axiosApi.put(`${BASE}/cau-hinh-quy-trinh/${id}`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Xóa cấu hình workflow
export function xoaCauHinhWorkflow(id: number) {
  try {
    return axiosApi.delete(`${BASE}/cau-hinh-quy-trinh/${id}`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}
